const Backofficebff: string = import.meta.env.VITE_BACKOFFICEBFF!;

export const BatchOutputCommandURL = {
    Approve: Backofficebff + '/v1/batch-output/approve',
    Reject: Backofficebff + '/v1/batch-output/reject',
    Regenerate: Backofficebff + '/v1/batch-output/regenerate',
    SendToPhotoshop: Backofficebff + '/v1/batch-output/send-to-photoshop',
};
